import { tasks, columns } from './data';

export const getBoards = () => columns;
export const getTasks = () => tasks;

export const getTasksByColumn = id =>
    tasks.filter(task => task.column === id).sort((task, next) => task.order - next.order);

export const getTaskById = id => tasks.find(task => task.id === id);
